import AuthRepository from '~/repository/authRepository'
import SerialRepository from '~/repository/serialRepository'
import ContactRepository from '~/repository/contactRepository'

export default (context, inject) => {
  const authRepository = new AuthRepository(context.$axios)
  context.$authRepository = authRepository
  inject('authRepository', authRepository)

  const serialRepository = new SerialRepository(context.$axios)
  context.$serialRepository = serialRepository
  inject('serialRepository', serialRepository)

  const contactRepository = new ContactRepository(context.$axios)
  context.$contactRepository = contactRepository
  inject('contactRepository', contactRepository)
}
